<template >
  <v-container fluid id="public-portal-page">
    <v-card id="public-portal-card" elevation="0" class="px-6 py-0 card">

      <v-row v-for="(row, rowIndex) in portal.layout" :key="rowIndex">
        <!-- TITRE -->
        <v-col cols="12" class="pt-1" v-if="row === 'title'">
          <div :class="{
              'pt-8': $vuetify.breakpoint.height === 667,
              'pt-12': $vuetify.breakpoint.height < 885 && $vuetify.breakpoint.height !== 667,
              'pt-2': $vuetify.breakpoint.height > 950,
            }" :style="{ color: portal.colorTitle }">
            <strong>{{ portal.title }}</strong>
          </div>
        </v-col>
        <v-col cols="12" :class="{
            'pb-1': $vuetify.breakpoint.height === 667,
            'pt-3': $vuetify.breakpoint.height < 885 && $vuetify.breakpoint.height > 667,
            'pb-2': $vuetify.breakpoint.height > 950,
          }" v-if="row === 'message'">
          <div class="pa-0" :style="{ color: portal.colorMessage }" v-html="portal.messageTop"></div>
        </v-col>
        <v-col cols="12" class="img-div pa-0 ma-0" v-if="row === 'image'">
          <v-img :height="$vuetify.breakpoint.height === 667 ? 120 : 165" v-if="portal.fileInputImgPreview !== null"
            :src="portal.fileInputImgPreview"></v-img>
          <v-img :height="$vuetify.breakpoint.height === 667 ? 120 : 165" v-else
            src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cmVzdGF1cmFudHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"></v-img>
        </v-col>
        <v-col cols="12" v-if="row === 'form'">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card-text class="pb-0"><strong>Veuillez renseigner les informations suivantes:</strong></v-card-text>
              <v-text-field v-model="portalData.user" class="mx-4 py-0" placeholder="Nom et Prénom"
                hide-details=""></v-text-field>
              <v-text-field v-model="portalData.mail" class="mx-4" placeholder="Email (optionnel)"
                hide-details=""></v-text-field>
              <v-text-field v-model="portalData.phone" class="mx-4 " placeholder="N° Mobile"
                hide-details=""></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0 my-0" align="center">
              <v-checkbox v-model="checkbox" label="Je m'inscris au programme de fidelité" hide-details="">
                <template v-slot:label>
                  <div class="tooltip-text">
                    Je m'inscris au
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" :href="portal.fidelity_program" @click.stop v-on="on">
                          Programme de fidelité
                        </a>
                      </template>
                      Lien vers le programme fidelité
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="py-0 my-0 pb-4">
              <v-checkbox v-if="portal.switchStatus" v-model="checkbox2"
                label="Covid-19 : Vos coordonnées pour faciliter la recherche des cas contacts." hide-details="">
                <template v-slot:label>
                  <div class="tooltip-text">
                    Covid-19 :
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" href="" @click.stop v-on="on">
                          Vos coordonnées si cas contacts.
                        </a>
                      </template>
                      Lien vers informations Covid
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="my-0" :class="{
                'py-0': $vuetify.breakpoint.height === 667,
                'py-1': $vuetify.breakpoint.height > 667,
              }">
              <v-btn @click="updateValue(portalData)" hide-details="" :large="$vuetify.breakpoint.height < 820"
                :x-large="$vuetify.breakpoint.height > 820" class="theme-btn shape-rounded filled-purple">Se
                Connecter</v-btn>
            </v-col>
            <v-col cols="12" class="py-0 my-0">
              <v-checkbox class="py-0" v-model="checkbox3" label="J’accepte la politique de confidentialité"
                hide-details="">
                <template v-slot:label>
                  <div class="tooltip-text">
                    J'accepte la
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" :href="portal.address_confidentiality" @click.stop v-on="on">
                          politique de confidentialité
                        </a>
                      </template>
                      Lien vers politique de confidentialité
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" class="py-0 my-0">
              <v-checkbox class="py-0" v-model="checkbox4" label="J’accepte les conditions générales de services"
                hide-details="">
                <template v-slot:label>
                  <div class="tooltip-text">
                    J'accepte les
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a target="_blank" :href="portal.address_cgu" @click.stop v-on="on">
                          conditions générales de services.
                        </a>
                      </template>
                      Lien vers CGS
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
              <v-card-text :class="{
                  'pa-2': $vuetify.breakpoint.height === 667,
                  'pb-6': $vuetify.breakpoint.height > 667,
                }"><strong class="infos">Vos informations sont sécurisées et resteront
                  confidentielles.</strong></v-card-text>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

export default {
  data: () => {
    return {
      checkbox: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      layouts: [
        {
          selected: true,
          bgwhite: true,
          layout: ["title", "message", "image", "form"],
        },
        {
          selected: false,
          bgwhite: false,
          layout: ["title", "form", "image", "message"],
        },
        {
          selected: false,
          bgwhite: false,
          layout: ["title", "image", "message", "form"],
        },
      ],
    };
  },
  props: {
    portal: {
      type: Object,
      default: () => {
        return {
          title: "",
          messageTop: "",
          fileInputImg: null,
          fileInputImgPreview: null,
          switchStatus: false,
          colorTitle: null,
          colorMessage: null,
          address_cgu: "",
          address_confidentiality: "",
          fidelity_program: "",
          messageBot: "",
          fileInputDoc: null,
          menuUrl: "",
          layout: null
        };
      },
    },
  },

  methods: {
    loadPublicPortalData() {
      this.$store.dispatch('portal/loadPublicPortalData', {
        parameters: {
          establishment_id: 1,
          success: (response) => {
            return this.portalData();
          }
        },
      });
    },
    updateValue(portalData) {
      this.$emit("input", portalData);
      return this.portalData;
    },
  },

  computed: {
    publicPortalLoading() {
      return this.$store.state.portal.portal.publicPortalLoading;
    },
    portalData() {
      let publicPortalData = this.$store.state.portal.portal.publicPortal;
      this.portal.title = publicPortalData.title;
      this.portal.messageTop = publicPortalData.message;
      this.portal.fileInputImg = publicPortalData.banner_image;
      this.portal.fileInputImgPreview = publicPortalData.banner_image;
      this.portal.switchStatus = publicPortalData.toggle_covid;
      this.portal.colorTitle = publicPortalData.color_main;
      this.portal.colorMessage = publicPortalData.color_secondary;
      this.portal.menuUrl = publicPortalData.menu;
      this.portal.address_cgu = publicPortalData.address_cgu;
      this.portal.address_confidentiality = publicPortalData.address_confidentiality;
      this.portal.fidelity_program = publicPortalData.fidelity_program;
      this.portal.layout = publicPortalData.layout;

      return this.$store.state.portal.portal.publicPortal;
    },
  },

  created() {
    document.body.querySelector('.v-main__wrap').style.backgroundColor = '#ffffff'
    this.loadPublicPortalData();
    this.portal.layout = this.layouts[0].layout;
    this.portalData = JSON.parse(JSON.stringify(this.portal));
  },
};
</script>

<style  lang="scss" >
#public-portal-page {

  // .public-portal-card {
  .card {
    overflow-y: hidden !important;
    // overflow: auto;
    margin-top: -11%;
    top: 19px !important;
    margin-right: 9px;
    margin-left: 11px;
    border-bottom-left-radius: 40px !important;
    border-bottom-right-radius: 40px !important;
  }

  .img-div {
    background-color: lightgrey;
  }

  // }
}
</style>
